module.exports = __webpack_public_path__ + "img/guide15.e03d5df7.jpg";